var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeam(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.14232 5.20291C7.14232 6.36839 6.18338 7.31239 4.99946 7.31239C3.81687 7.31239 2.85659 6.36839 2.85659 5.20291C2.85659 4.03743 3.81687 3.09343 4.99946 3.09343C6.18338 3.09343 7.14232 4.03743 7.14232 5.20291Z",
    fill: "#191404"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1433 5.20291C27.1433 6.36839 26.183 7.31239 25.0004 7.31239C23.8165 7.31239 22.8576 6.36839 22.8576 5.20291C22.8576 4.03743 23.8165 3.09343 25.0004 3.09343C26.183 3.09343 27.1433 4.03743 27.1433 5.20291Z",
    fill: "#191404"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5718 3.79614C18.5718 5.73818 16.9727 7.31239 14.9999 7.31239C13.0272 7.31239 11.4281 5.73818 11.4281 3.79614C11.4281 1.85543 13.0272 0.28125 14.9999 0.28125C16.9727 0.28125 18.5718 1.85546 18.5718 3.79614Z",
    fill: "#191404"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8576 13.6408V22.5473C22.8576 22.7332 22.7826 22.9125 22.6473 23.0443C22.5147 23.1762 22.3326 23.25 22.1424 23.25H7.85753C7.66735 23.25 7.48522 23.1762 7.3526 23.0443C7.21734 22.9125 7.14234 22.7332 7.14234 22.5473V13.6408C7.14234 10.9222 9.38161 8.71915 12.1433 8.71915H17.8567C20.6183 8.71915 22.8576 10.9222 22.8576 13.6408Z",
    fill: "#191404"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.79067 8.98275C7.37012 8.81268 6.91076 8.71907 6.42859 8.71907H3.5719C1.59913 8.71907 0 10.2933 0 12.234V19.735C0 20.1226 0.320089 20.4377 0.713831 20.4377H5.71476V13.6407C5.71476 11.7989 6.51431 10.1404 7.79067 8.98275Z",
    fill: "#191404"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2852 20.4378H29.2862C29.6799 20.4378 30 20.1227 30 19.7351V12.2341C30 10.2934 28.4009 8.71919 26.4281 8.71919H23.5714C23.0893 8.71919 22.6299 8.81279 22.2093 8.98287C23.4857 10.1404 24.2852 11.799 24.2852 13.6409V20.4378Z",
    fill: "#191404"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam);
export default __webpack_public_path__ + "static/media/team.9f379c15.svg";
export { ForwardRef as ReactComponent };